export enum LoopbackFilterLogicalOperatorEnum {
  AND = "and",
  OR = "or",
}
